import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6c58eed7&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.hva/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BAlert, BCol, BRow, BButton, BCard, BForm, BContainer} from 'bootstrap-vue'
    installComponents(component, {BAlert, BCol, BRow, BButton, BCard, BForm, BContainer})
    

export default component.exports